<div class="or-multiselect" [ngClass]="{ 'edit-mode': isEditMode }" name="multiselect.form">
  @if ((selectedCount$ | async) + (unselectedCount$ | async) > 0) {
    <ul
      class="or-inline-items or-muliselect-items or-multiselect-active-items"
      >
      @for (option of selectedOptions$ | async; track option) {
        <li
          class="or-inline-item or-multiselect-item or-multiselect-active-item"
          >
          <span class="or-multiselect-item-label">{{ label(option) }}</span>
          @if (isEditMode) {
            <button
              class="or-button or-iconic or-multiselect-remove-item"
              (click)="unselect(option)"
              >
              <span class="or-icon or-tiny or-icon-cross"></span>
            </button>
          }
        </li>
      }
      <li class="or-inline-item" [hidden]="!(isEditMode && (unselectedCount$ | async) > 0)">
        <form #innerForm="ngForm">
          <select [id]='id' name="state" ngModel (change)="change(innerForm.value?.state)">
            <option [selected]='true' disabled [value]='undefined'>--- Add another ---</option>
            @for (option of unselectedOptions$ | async; track option) {
              <option [ngValue]="option">
                {{ label(option) }}
              </option>
            }
          </select>
        </form>
      </li>
    </ul>
  }
</div>
